
<section class="date-picker">
  <!-- <div>{{error }}222</div> -->
  <date-picker class="datePicker" :class="{'erroDate' : error}" ref="datePicker" v-model:value="state.time" :lang="state.langType"
  type="date"  :editable="true" :clearable="clearable"
  prefix-class="xmx"  format="YYYY/MM/DD" v-model:open="state.open" @confirm="datePickerConfirm"
  :disabled="isDisable" @close="closePicker" :disabled-date="notBeforeThisDay"
  :confirm="true" confirm-text="Apply" @pick="calendarChange">
    <template #footer="{ emit }">
      <div class="datePicker-footer">
        <div class="datePickerButtonBlock">
          <Button @onClick="applyDate(emit)" type="full" style="margin-right: 24px;" wd="ssmd" h="smd" :disable="!state.temp" :text="t('__common.__apply')" class="buttonEach"></Button>
          <Button @onClick="closePicker" type="border"  wd="ssmd" h="smd" :text="t('__common.__cancel')" class="buttonEach aaa"></Button>
        </div>
      </div>
    </template>
  </date-picker>
  <!-- <div>time : {{state.time}}</div> -->
  <div :class="{'erroSpan' : error}" v-if="error"> {{error}}</div>
</section>

